/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { DriversState } from '@drivers/store/drivers.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectDriversState = createFeatureSelector<DriversState>('drivers');

export const getDrivers = createSelector(selectDriversState, state => state.drivers);
export const getIsDriverActionPending = createSelector(selectDriversState, state => state.isActionPending);
export const getCurrentDriver = createSelector(selectDriversState, state => state.currentDriver);
